import React, { useState } from 'react';
import { EaseDrawer } from '../../../libs/EaseDrawer';
import { Descriptions, Badge, Typography, Popconfirm, Button } from 'antd';
import { TALLY_INVOICE_STATUS_TYPES, } from '../../../constants';
import { Text4 } from '../../../styles';
import { printRupee } from '../../../app_methods';
import { TallyInvoiceAttemptsDrawer } from './attempts';
import { PermissionHoc } from '../../HOC';
import moment from 'moment';
import './index.scss';


const TallyInvoiceDetails = (props) => {
    const tallyInvoice = props.payoutLink || {};
    const [showAttemptsDrawer, setShowAttemptsDrawer] = useState(false);

    const toggleAttemptsDrawer = () => {
        setShowAttemptsDrawer(!showAttemptsDrawer);
    };

    return (
        <EaseDrawer
            className="payout-link-details-drawer"
            visible={props.visible}
            onClose={props.onClose}
            hideHeader
            hideFooter
            width={525}
        >
            <Typography.Title className="mt-4" level={4}>Tally Invoice Details</Typography.Title>
            <div className="w-100 d-flex justify-content-end">
                <Button onClick={toggleAttemptsDrawer}>Payment Attempts</Button>
            </div>
            <Descriptions className="mt-4" title={false} column={1} bordered size="small">
                <Descriptions.Item label="Payee Name">{tallyInvoice.beneficiary_account_name}</Descriptions.Item>
                <Descriptions.Item label="Amount">{printRupee(tallyInvoice.total_amount)}</Descriptions.Item>
                {tallyInvoice.payment_mode ? <Descriptions.Item label="Payment Mode">{tallyInvoice.payment_mode}</Descriptions.Item>: null}
                <Descriptions.Item label="Invoice Date">{tallyInvoice.invoice_date && moment(tallyInvoice.invoice_date).format("LL")}</Descriptions.Item> 
                <Descriptions.Item label="Due Date">{tallyInvoice.due_date && moment(tallyInvoice.due_date).format("LL")}</Descriptions.Item> 
                {
                    tallyInvoice.status ?
                        <Descriptions.Item label="Status">
                            <div className="w-100 d-flex justify-content-between align-items-center">
                            <Badge color={TALLY_INVOICE_STATUS_TYPES[tallyInvoice.status].color} text={<Text4>{TALLY_INVOICE_STATUS_TYPES[tallyInvoice.status].label}</Text4>} />
                            </div>
                        </Descriptions.Item>
                        :
                        null
                }
                <Descriptions.Item label="Created At">{tallyInvoice.created_at && moment(tallyInvoice.created_at).format("LL")}</Descriptions.Item>
            </Descriptions>

            <TallyInvoiceAttemptsDrawer
                visible={showAttemptsDrawer}
                onClose={toggleAttemptsDrawer}
                tallyInvoice={tallyInvoice}
            />

        </EaseDrawer>
    )
};

export { TallyInvoiceDetails };